import {
  Component,
  OnDestroy,
  OnInit,
  AfterViewInit,
  ElementRef,
} from "@angular/core";

import { InsaService, LocalizeService } from "../../insa-services";
import { SecPricesExtendedModel } from "../../insa-models";
import { SharedMethodsModule } from "../../insa-custom-scripts";
import { appStateProvider } from "../../insa-providers";
import { GenericChartsModule } from "../../insa-custom-scripts";

@Component({
  templateUrl: "./stock-chart.component.html",
})
export class SecurityPricesComponent implements OnInit, OnDestroy {
  private secPricesSubscription;
  constructor(
    private _appStateProvider: appStateProvider,
    private _insaService: InsaService,
    private _localize: LocalizeService,
    private _element: ElementRef,
  ) {
    this.secPricesSubscription =
      this._insaService.SecurityPricesChartEvent.subscribe((secPrices) =>
        this.refreshSecPricesChart(secPrices),
      );
  }

  private refreshSecPricesChart(secPrices: SecPricesExtendedModel) {
    if (
      secPrices !== undefined &&
      secPrices.SecurityPricesCollection.length > 0
    ) {
      let newSecNumber = secPrices.SecurityPricesCollection[0].SecurityNumber;
      let KendoSecPricesDropdown: kendo.ui.DropDownList =
        $("#secPrices").data("kendoDropDownList");
      KendoSecPricesDropdown.value(newSecNumber);
      GenericChartsModule.InitKendoGenericMultipaneStockChart(
        "#GenericSecurityPrices",
        secPrices.SecurityPricesCollection,
        "area",
        "column",
        "Price",
        "SECURITY PRICES",
        true,
        "Date",
        true,
        secPrices.MinDate,
        secPrices.MaxDate,
        "Volume",
        secPrices.MinVolume,
        secPrices.MaxVolume,
        $(".canvas").height() - $("#customButtonRow").height(),
        $(".canvas").width(),
        this._localize.getLocalizedResource("Res711"),
      );
      GenericChartsModule.KendoInitTimeIntervalPickerForSecPrices(
        "#GenericSecurityPrices",
        secPrices.MinDate,
        secPrices.MaxDate,
      );
      $("#securityMessage").html("");
    } else {
      GenericChartsModule.InitKendoGenericMultipaneStockChart(
        "#GenericSecurityPrices",
        [],
        "area",
        "column",
        "Price",
        "SECURITY PRICES",
        false,
        "Date",
        false,
        null,
        null,
        "Volume",
        null,
        null,
        undefined,
        undefined,
        this._localize.getLocalizedResource("Res711"),
      );
      GenericChartsModule.KendoInitTimeIntervalPickerForSecPrices(
        "#GenericSecurityPrices",
        null,
        null,
      );
      kendo.ui.progress($(".stockChart-loading"), false);
      $("#securityMessage").html(SharedMethodsModule.noDataTemplate());
    }
  }

  private onResize(event) {
    let secPricesChart: kendo.dataviz.ui.StockChart = $(
      "#GenericSecurityPrices",
    ).data("kendoStockChart");
    if (secPricesChart !== undefined) {
      secPricesChart.options.chartArea = {
        background: "",
        height: $(".canvas").height() - $("#customButtonRow").height(),
        width: $(".canvas").width(),
      };
      secPricesChart.redraw();
    }
  }

  private initSecPricesDropdown() {
    let dropdownOptions: kendo.ui.DropDownListOptions = {};
    dropdownOptions.dataTextField = "SecName";
    dropdownOptions.dataValueField = "SecNumber";
    dropdownOptions.dataSource = this._insaService.allPortfoliosNoLiquidity;
    if (this._insaService.allPortfoliosNoLiquidity.length > 0) {
      let secNumber: string;
      secNumber = this._insaService.allPortfoliosNoLiquidity
        .slice(0)
        .sort(function (a, b) {
          return b.Valuation - a.Valuation;
        })[0].SecNumber;
      dropdownOptions.value = secNumber;
      dropdownOptions.change = this.getSecurityPrices.bind(this);
    }
    $("#secPrices").kendoDropDownList(dropdownOptions);
  }

  getSecurityPrices() {
    kendo.ui.progress($(".stockChart-loading"), true);
    let secNumber = $("#secPrices").data("kendoDropDownList").value();
    this._insaService.getSecPricesChart(secNumber);
  }

  ngOnInit() {
    kendo.ui.progress($(".stockChart-loading"), true);
    this.onResize(null);
    this.initSecPricesDropdown();
    if (!this._appStateProvider.fetchingSecurityPrices) {
      if (this._insaService.allPortfoliosNoLiquidity.length > 0) {
        let secNumber: string;
        secNumber = this._insaService.allPortfoliosNoLiquidity
          .slice(0)
          .sort(function (a, b) {
            return b.Valuation - a.Valuation;
          })[0].SecNumber;
        this._insaService.getSecPricesChart(secNumber);

        $("#securityMessage").html("");
      } else {
        $("#securityMessage").html(SharedMethodsModule.noDataTemplate());
        kendo.ui.progress($(".stockChart-loading"), false);
      }
    } else {
      //kendo.ui.progress($(".stockChart-loading"), false);
    }
  }

  ngAfterViewInit() {
    this._localize.applyTranslations(this._element.nativeElement);
  }

  ngOnDestroy() {
    this.secPricesSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-charts/stock-chart.component.ts